/**
 * KDS Rating — closed wrapper over Chakra `RatingGroup`.
 *
 * Sizes follow Chakra Rating (`xs` | `sm` | `md` | `lg`). Default `md` maps to
 * ~24px stars (Figma Star/Filled 24×24 on the in-app review card).
 *
 * Default `colorPalette` is `brand` so filled stars use Primary/500 via
 * `colorPalette.solid` (no raw hex in consumers).
 */
export const ratingSizes = ['xs', 'sm', 'md', 'lg'] as const;

export type RatingSize = (typeof ratingSizes)[number];

export const ratingDefaultSize: RatingSize = 'md';

export const ratingDefaultColorPalette = 'brand' as const;

/** Gap between star items (Figma review card gap 6px → spacing token `1.5`). */
export const ratingItemGap = '1.5' as const;
